<div class="dash">

  <!-- ✅ FEATURE 7 — High severity incident alert panel -->
  <!-- Slides in from top when a critical/high incident is reported -->
  <div class="dash__alert-overlay" *ngIf="showAlertPanel && highSeverityAlerts.length > 0">
    <div class="dash__alert-panel">

      <div class="dash__alert-header">
        <div class="dash__alert-title">
          <span class="dash__alert-pulse"></span>
          🚨 High Severity Incident Alert
        </div>
        <div class="dash__alert-header-actions">
          <button class="dash__alert-dismiss-all"
                  (click)="dismissAllAlerts()">
            Dismiss All
          </button>
          <button class="dash__alert-view-btn"
                  (click)="navigateToIncidents()">
            View All Incidents →
          </button>
        </div>
      </div>

      <div class="dash__alert-list">
        <div class="dash__alert-item"
             *ngFor="let alert of highSeverityAlerts"
             [class.dash__alert-item--critical]="alert.severity === 'Critical'"
             [class.dash__alert-item--high]="alert.severity === 'High'">

          <div class="dash__alert-item-header">
            <span class="dash__alert-severity-badge"
                  [class.dash__alert-severity-badge--critical]="alert.severity === 'Critical'"
                  [class.dash__alert-severity-badge--high]="alert.severity === 'High'">
              {{ alert.severityLabel }}
            </span>
            <span class="dash__alert-time">
              {{ alert.reportedAt | date:'HH:mm' }}
            </span>
            <button class="dash__alert-close"
                    (click)="dismissAlert(alert.id)">×</button>
          </div>

          <p class="dash__alert-incident-title">{{ alert.title }}</p>
          <p class="dash__alert-message">{{ alert.message }}</p>

          <div class="dash__alert-meta">
            <span>👤 {{ alert.reporterName }}</span>
            <span *ngIf="alert.location">📍 {{ alert.location }}</span>
            <span>🏷 {{ alert.category }}</span>
          </div>

        </div>
      </div>

    </div>
  </div>

  <!-- ── Page Header ─────────────────────────────────── -->
  <div class="dash__header">
    <div>
      <h1 class="dash__title">Dashboard</h1>
      <p class="dash__subtitle">
        Welcome back — here's what's happening today.
      </p>
    </div>
    <div class="dash__header-actions">

      <!-- AI unread badge -->
      <div class="dash__ai-badge" *ngIf="aiUnreadCount > 0">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M12 8v4M12 16h.01" stroke="currentColor"
                stroke-width="2" stroke-linecap="round"/>
        </svg>
        {{ aiUnreadCount }} new AI insight{{ aiUnreadCount > 1 ? 's' : '' }}
      </div>

      <!-- Incident alert bell -->
      <button class="dash__incident-bell"
              *ngIf="hasHighAlerts"
              (click)="showAlertPanel = !showAlertPanel"
              title="View incident alerts">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="round"/>
        </svg>
        <span class="dash__incident-bell-count">
          {{ highSeverityAlerts.length }}
        </span>
      </button>

      <span class="dash__date">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="4" width="18" height="18" rx="2"
                stroke="currentColor" stroke-width="1.8"/>
          <line x1="16" y1="2" x2="16" y2="6"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="8" y1="2" x2="8" y2="6"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="3" y1="10" x2="21" y2="10"
                stroke="currentColor" stroke-width="1.8"/>
        </svg>
        {{ today | date:'EEEE, MMM d, y' }}
      </span>

      <button class="dash__refresh-btn"
              (click)="refresh()"
              [class.spinning]="refreshing">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path d="M3 12C3 7 7 3 12 3s9 4 9 9-4 9-9 9"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <polyline points="20.5 3 20.5 8 15.5 8"
                    stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
          <polyline points="3.5 21 3.5 16 8.5 16"
                    stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Refresh
      </button>
    </div>
  </div>

  <!-- ── Stat Cards ─────────────────────────────────── -->
  <div class="stats-grid" *ngIf="stats">
    <div class="stat-card stat-card--jobs">
      <div class="stat-card__inner">
        <div class="stat-card__body">
          <span class="stat-card__label">Total Jobs</span>
          <span class="stat-card__value">{{ stats.jobs }}</span>
          <span class="stat-card__sub">
            <span class="stat-chip stat-chip--warning">Active</span>
          </span>
        </div>
        <div class="stat-card__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2"
                  stroke="currentColor" stroke-width="1.8"/>
            <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="stat-card__bar"></div>
    </div>

    <div class="stat-card stat-card--workers">
      <div class="stat-card__inner">
        <div class="stat-card__body">
          <span class="stat-card__label">Total Workers</span>
          <span class="stat-card__value">{{ stats.workers }}</span>
          <span class="stat-card__sub">
            <span class="stat-chip stat-chip--info">Registered</span>
          </span>
        </div>
        <div class="stat-card__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
            <path d="M2 20C2 17 5 14 9 14"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
            <path d="M14 20C14 17.8 15.8 16 17 16"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="stat-card__bar"></div>
    </div>

    <div class="stat-card stat-card--logs">
      <div class="stat-card__inner">
        <div class="stat-card__body">
          <span class="stat-card__label">Logs Today</span>
          <span class="stat-card__value">{{ stats.logsToday }}</span>
          <span class="stat-card__sub">
            <span class="stat-chip stat-chip--teal">Submitted</span>
          </span>
        </div>
        <div class="stat-card__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6C5.4 2 5 2.4 5 3v18c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V8l-5-6z"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <polyline points="14 2 14 8 20 8" stroke="currentColor"
                      stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="16" y1="13" x2="8" y2="13"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="16" y1="17" x2="8" y2="17"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="stat-card__bar"></div>
    </div>

    <div class="stat-card stat-card--online">
      <div class="stat-card__inner">
        <div class="stat-card__body">
          <span class="stat-card__label">Workers Online</span>
          <span class="stat-card__value">{{ stats.workersOnline }}</span>
          <span class="stat-card__sub">
            <span class="stat-chip stat-chip--success">
              <span class="stat-chip__dot"></span>Live now
            </span>
          </span>
        </div>
        <div class="stat-card__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <path d="M12 7V12L15 14" stroke="currentColor"
                  stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      <div class="stat-card__bar"></div>
    </div>
  </div>

  <!-- Stats skeleton -->
  <div class="stats-grid" *ngIf="loadingStats">
    <div class="stat-card stat-card--skeleton" *ngFor="let i of [1,2,3,4]">
      <div class="skeleton-block skeleton-block--tall"></div>
    </div>
  </div>

  <!-- ── Main Grid ──────────────────────────────────── -->
  <div class="dash__grid">

    <!-- Left column -->
    <div class="dash__col dash__col--left">

      <!-- Live Workers -->
      <div class="panel panel--wide">
        <div class="panel__head">
          <div class="panel__head-left">
            <span class="panel__live-dot"></span>
            <h3 class="panel__title">Live Workers</h3>
            <span class="panel__count" *ngIf="!loadingWorkers">
              {{ liveWorkers.length }}
            </span>
          </div>
          <a routerLink="/live-map" class="panel__action-link">
            View Map
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M13 6L19 12L13 18"
                    stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <div class="panel__loading" *ngIf="loadingWorkers">
          <div class="spinner"></div>
          <span>Fetching live locations…</span>
        </div>

        <div class="table-wrap" *ngIf="!loadingWorkers">
          <table class="fo-table" *ngIf="pagedWorkers.length > 0">
            <thead>
              <tr>
                <th>Worker</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Last Update</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let worker of pagedWorkers">
                <td>
                  <div class="worker-cell">
                    <span class="worker-id">{{ worker.workerName }}</span>
                  </div>
                </td>
                <td class="coord">{{ worker.latitude | number:'1.4-4' }}</td>
                <td class="coord">{{ worker.longitude | number:'1.4-4' }}</td>
                <td class="timestamp">
                  {{ worker.timestamp | date:'MMM d, h:mm a' }}
                </td>
                <td>
                  <span class="status-pill"
                        [class.status-pill--online]="worker.isOnline"
                        [class.status-pill--offline]="!worker.isOnline">
                    <span class="status-pill__dot"></span>
                    {{ worker.isOnline ? 'Online' : 'Offline' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="panel__empty" *ngIf="pagedWorkers.length === 0">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22S19 14.2 19 9C19 5.1 15.9 2 12 2Z"
                    stroke="currentColor" stroke-width="1.5"/>
              <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            <p>No workers are currently online.</p>
          </div>

          <div class="pagination" *ngIf="totalWorkerPages > 1">
            <button class="pagination__btn"
                    (click)="workerPage = workerPage - 1; updatePagedWorkers()"
                    [disabled]="workerPage === 1">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <span class="pagination__info">
              Page {{ workerPage }} of {{ totalWorkerPages }}
            </span>
            <button class="pagination__btn"
                    (click)="workerPage = workerPage + 1; updatePagedWorkers()"
                    [disabled]="workerPage === totalWorkerPages">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- AI Insights Panel -->
      <div class="panel panel--ai">
        <app-ai-insights-panel></app-ai-insights-panel>
      </div>

    </div>

    <!-- Right column -->
    <div class="dash__col dash__col--right">

      <!-- Recent Activity -->
      <div class="panel panel--narrow">
        <div class="panel__head">
          <div class="panel__head-left">
            <h3 class="panel__title">Recent Activity</h3>
            <span class="panel__count" *ngIf="activities.length > 0">
              {{ activities.length }}
            </span>
          </div>
        </div>

        <div class="panel__loading" *ngIf="loadingActivity">
          <div class="spinner"></div>
        </div>

        <div class="activity-list" *ngIf="!loadingActivity">
          <div class="activity-item" *ngFor="let a of pagedActivities">
            <div class="activity-avatar">
              {{ a.userName?.charAt(0)?.toUpperCase() }}
            </div>
            <div class="activity-body">
              <p class="activity-text">
                <strong>{{ a.userName }}</strong> logged
                <span class="activity-hours">{{ a.hoursSpent }}h</span>
                on <strong>{{ a.jobTitle }}</strong>
              </p>
              <span class="activity-time">
                {{ a.createdUtc | date:'MMM d, h:mm a' }}
              </span>
            </div>
          </div>

          <div class="panel__empty" *ngIf="activities.length === 0">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10"
                      stroke="currentColor" stroke-width="1.5"/>
              <line x1="12" y1="8" x2="12" y2="12"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="12" cy="16" r="0.5" fill="currentColor"
                      stroke="currentColor" stroke-width="1"/>
            </svg>
            <p>No recent activity yet.</p>
          </div>

          <div class="pagination pagination--compact"
               *ngIf="totalActivityPages > 1">
            <button class="pagination__btn"
                    (click)="activityPage = activityPage - 1; updatePagedActivities()"
                    [disabled]="activityPage === 1">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <span class="pagination__info">
              {{ activityPage }} / {{ totalActivityPages }}
            </span>
            <button class="pagination__btn"
                    (click)="activityPage = activityPage + 1; updatePagedActivities()"
                    [disabled]="activityPage === totalActivityPages">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>